


















































import { Component, Prop } from 'vue-property-decorator';

import RotateIcon from '@/components/icons/RotateIcon.vue';
import CoinAnatomy from '@/components/icons/CoinAnatomy.vue';
import CoinAnatomySafari from '@/components/icons/CoinAnatomySafari.vue';
import CoinCustomizationForm from '@/componentsV2/templates/CoinCustomizationForm/CoinCustomizationForm.vue';

import YourDigitalCoinBase from '@/views/BusinessOnboarding/online/Steps/YourDigitalCoinBase.vue';

import { isSafari } from '@/utils/is-safari';

@Component({
  components: {
    CoinAnatomy,
    CoinAnatomySafari,
    CoinCustomizationForm,
    RotateIcon
  }
})
export default class CoinFrontAndBack extends YourDigitalCoinBase {
  @Prop() formData!: any;

  get componentToRender() {
    return isSafari() ? 'CoinAnatomySafari' : 'CoinAnatomy';
  }
}
